export const darkTheme = {
    bg: "#000000",
    bgLight: "#000000",
    primary: "#ffffff",
    text_primary: "#ffffff",
    text_secondary: "#cccccc",
    card: "#111111",
    card_light: '#111111',
    button: "#ffffff",
    white: "#ffffff",
    black: "#000000",
}